import styled from "@emotion/styled";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  id: number;
  childNodesSortableIds: string[];
}

export const LayerChildLayers = ({ children, childNodesSortableIds }: Props) => {
  if (!childNodesSortableIds.length) return null;
  return <LayerChildren>{children}</LayerChildren>;
};

const LayerChildren = styled.div`
  margin: 0;
  background: transparent;
  position: relative;
`;
